import { URL_CONSTANT } from "~/constant/urlConstant";
import { AM_CONSTANT } from "~/constant/amConstant";
import { DES } from "crypto-js";

export const MENU_CONSTANT = {
    MENU_1DEPTH_NAME_MAP: {
        intro: AM_CONSTANT.MENU_NAME.INTRO.TITLE,
        product: AM_CONSTANT.MENU_NAME.PRODUCT.TITLE,
        market: AM_CONSTANT.MENU_NAME.MARKET.TITLE,
        productSupport: AM_CONSTANT.MENU_NAME.PRODUCT_SUPPORT.TITLE,
        customerSupport: AM_CONSTANT.MENU_NAME.CUSTOMER_SUPPORT.TITLE,
    },

    MENU_1DEPTH_URL_MAP: {
        intro: URL_CONSTANT.MENU_URL_PREFIX.USER_INTRO + URL_CONSTANT.MENU_URL_SUFFIX.INTRO.KCC,
        product: URL_CONSTANT.MENU_URL_PREFIX.USER_PRODUCT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT.MAIN,
        market: URL_CONSTANT.MENU_URL_PREFIX.USER_MARKET + URL_CONSTANT.MENU_URL_SUFFIX.MARKET.MAIN,
        productSupport: URL_CONSTANT.MENU_URL_PREFIX.USER_PRODUCT_SUPPORT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_SUPPORT.INTEGRATED_SEARCH,
        customerSupport: URL_CONSTANT.MENU_URL_PREFIX.USER_CUSTOMER_SUPPORT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT.INQUIRY,
    },

    MENU_INTRO_NAME_MAP: {
        intro_kcc: AM_CONSTANT.MENU_NAME.INTRO.KCC,
        intro_am: AM_CONSTANT.MENU_NAME.INTRO.AM,
        intro_globalNetwork: AM_CONSTANT.MENU_NAME.INTRO.GLOBAL_NETWORK,
        newsroom_list: AM_CONSTANT.MENU_NAME.INTRO.NEWSROOM,
        newsroom_view : AM_CONSTANT.MENU_NAME.INTRO.NEWSROOM,
    },

    MENU_INTRO_URL_MAP: {
        intro_kcc: URL_CONSTANT.MENU_URL_PREFIX.USER_INTRO + URL_CONSTANT.MENU_URL_SUFFIX.INTRO.KCC,
        intro_am: URL_CONSTANT.MENU_URL_PREFIX.USER_INTRO + URL_CONSTANT.MENU_URL_SUFFIX.INTRO.AM,
        intro_globalNetwork: URL_CONSTANT.MENU_URL_PREFIX.USER_INTRO + URL_CONSTANT.MENU_URL_SUFFIX.INTRO.GLOBAL_NETWORK,
        newsroom_list: URL_CONSTANT.MENU_URL_PREFIX.USER_INTRO + URL_CONSTANT.MENU_URL_SUFFIX.INTRO.NEWSROOM.LIST,
        newsroom_view: URL_CONSTANT.MENU_URL_PREFIX.USER_INTRO + URL_CONSTANT.MENU_URL_SUFFIX.INTRO.NEWSROOM.VIEW,
    },

    MENU_PRODUCT_SUPPORT_NAME_MAP: {
        productSupport_integratedSearch: AM_CONSTANT.MENU_NAME.PRODUCT_SUPPORT.INTEGRATED_SEARCH,
        productSupport_technicalSupport: AM_CONSTANT.MENU_NAME.PRODUCT_SUPPORT.TECHNICAL_SUPPORT,
        productSupport_productCatalog: AM_CONSTANT.MENU_NAME.PRODUCT_SUPPORT.PRODUCT_CATALOG,
    },

    MENU_PRODUCT_SUPPORT_URL_MAP: {
        productSupport_integratedSearch: URL_CONSTANT.MENU_URL_PREFIX.USER_PRODUCT_SUPPORT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_SUPPORT.INTEGRATED_SEARCH,
        productSupport_technicalSupport: URL_CONSTANT.MENU_URL_PREFIX.USER_PRODUCT_SUPPORT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_SUPPORT.TECHNICAL_SUPPORT,
        productSupport_productCatalog: URL_CONSTANT.MENU_URL_PREFIX.USER_PRODUCT_SUPPORT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_SUPPORT.PRODUCT_CATALOG,
    },

    MENU_CUSTOMER_SUPPORT_NAME_MAP: {
        customerSupport_inquiry: AM_CONSTANT.MENU_NAME.CUSTOMER_SUPPORT.INQUIRY,
        customerSupport_contact: AM_CONSTANT.MENU_NAME.CUSTOMER_SUPPORT.CONTACT,
    },

    MENU_CUSTOMER_SUPPORT_URL_MAP: {
        customerSupport_inquiry: URL_CONSTANT.MENU_URL_PREFIX.USER_CUSTOMER_SUPPORT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT.INQUIRY,
        customerSupport_contact: URL_CONSTANT.MENU_URL_PREFIX.USER_CUSTOMER_SUPPORT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT.CONTACT,
    },

    MANAGER_SIDE_MENU_NAME_MAP: {
        productMgnt: {
            material: AM_CONSTANT.MANAGER_MENU_NAME.PRODUCT_MGNT.MATERIAL,
            product_classification: AM_CONSTANT.MANAGER_MENU_NAME.PRODUCT_MGNT.PRODUCT_CLASSIFICATION,
            product_detail: AM_CONSTANT.MANAGER_MENU_NAME.PRODUCT_MGNT.PRODUCT_DETAIL,
            application: AM_CONSTANT.MANAGER_MENU_NAME.PRODUCT_MGNT.APPLICATION,
            // datasheet: AM_CONSTANT.MANAGER_MENU_NAME.PRODUCT_MGNT.DATASHEET,
        },
        marketMgnt: {
            market: AM_CONSTANT.MANAGER_MENU_NAME.MARKET_MGNT.MARKET,
            function: AM_CONSTANT.MANAGER_MENU_NAME.MARKET_MGNT.FUNCTION,
        },
        documentMgnt: {
            attachment: AM_CONSTANT.MANAGER_MENU_NAME.DOC_MGNT.DOC,
            catalog: AM_CONSTANT.MANAGER_MENU_NAME.DOC_MGNT.CATALOG,
	        docShareAudit : AM_CONSTANT.MANAGER_MENU_NAME.DOC_MGNT.DOC_SHARE_AUDIT,
	        histVisit : AM_CONSTANT.MANAGER_MENU_NAME.DOC_MGNT.HIST_VISIT,
        },
	    popupMgnt: {
		    popup: AM_CONSTANT.MANAGER_MENU_NAME.POPUP_MGNT.POPUP,
	    },
        customerSupportMgnt: {
            personalEnquiry: AM_CONSTANT.MANAGER_MENU_NAME.CUSTOMER_SUPPORT_MGNT.PERSONAL,
            contact: AM_CONSTANT.MANAGER_MENU_NAME.CUSTOMER_SUPPORT_MGNT.CONTACT,
            information: AM_CONSTANT.MANAGER_MENU_NAME.CUSTOMER_SUPPORT_MGNT.INFORMATION,
            sendGroupMail: AM_CONSTANT.MANAGER_MENU_NAME.CUSTOMER_SUPPORT_MGNT.SEND_MAIL,
            newsRoom: AM_CONSTANT.MANAGER_MENU_NAME.CUSTOMER_SUPPORT_MGNT.NEWSROOM,
        },
    },

    MANAGER_SIDE_MENU_URL_MAP: {
        productMgnt: {
            material: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_PRODUCT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_MGNT.MATERIAL,
            product_classification: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_PRODUCT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_MGNT.PRODUCT_CLASSIFICATION,
            product_detail: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_PRODUCT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_MGNT.PRODUCT_LIST,
            application: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_PRODUCT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_MGNT.APPLICATION_LIST,
            // datasheet: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_PRODUCT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.PRODUCT_MGNT.DATASHEET,
        },
        marketMgnt: {
            market: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_MARKET_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.MARKET_MGNT.MARKET,
            function: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_MARKET_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.MARKET_MGNT.FUNCTION,
        },
        documentMgnt: {
            attachment: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_DOC_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.DOC_MGNT.ATTACHMENT,
            catalog: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_DOC_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.DOC_MGNT.CATALOG,
	        docShareAudit: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_DOC_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.DOC_MGNT.DOC_SHARE_AUDIT,
	        histVisit : URL_CONSTANT.MENU_URL_PREFIX.MANAGER_DOC_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.DOC_MGNT.HIST_VISIT,
        },
	    popupMgnt: {
			popup: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_POPUP_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.POPUP_MGNT.POPUP,
	    },
        customerSupportMgnt: {
            personalEnquiry: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_CUSTOMER_SUPPORT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT_MGNT.PERSONAL_EDIT,
            contact: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_CUSTOMER_SUPPORT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT_MGNT.CONTACT,
            information: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_CUSTOMER_SUPPORT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT_MGNT.INFORMATION,
            sendGroupMail: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_CUSTOMER_SUPPORT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT_MGNT.SEND_MAIL,
            newsRoom: URL_CONSTANT.MENU_URL_PREFIX.MANAGER_CUSTOMER_SUPPORT_MGNT + URL_CONSTANT.MENU_URL_SUFFIX.CUSTOMER_SUPPORT_MGNT.NEWSROOM,
        },
    },
};
